import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "loadingLoop":
            return ["loadingLoop"];
    }
};
const sprite = {
    loadingStart: [0, 14 + 13 / 30],
    loadingLoop: [11 + 11 / 30, 14 + 13 / 30],
};
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=loadingSound.js.map